export type FilledColumns = 2 | 3 | 4 | 5

export const filledColumns = (count: number): FilledColumns => {
  const full = ([4, 3, 5, 2] as const).find((cols) => count % cols === 0)
  return full ?? (Math.min(Math.max(count, 2), 4) as FilledColumns)
}
